import { CustomizedTypography } from '@components/Customized';
import styled from 'styled-components';
import { Divider } from '@material-ui/core';
import { ReactNode } from 'react';
import { colorSet } from '@components/Provider';

interface Props {
  error?: boolean;
  children?: ReactNode;
}
export default function BubbleTitle({ error, children }: Props) {
  return (
    <>
      <Wrapper>
        <CustomizedTypography
          variant="body1"
          fontWeight="700"
          color={error ? 'error' : 'primary'}
        >
          {children}
        </CustomizedTypography>
      </Wrapper>
      <BubbleDivider />
    </>
  );
}

const Wrapper = styled('div')({
  padding: `20px 16px 16px 16px`,
  '& p': {
    wordBreak: 'break-all'
  }
});

const BubbleDivider = styled(Divider)`
  background-color: ${colorSet.gray300};
`;
